import { makeStyles, withStyles, createTheme } from '@material-ui/core/styles';
import StepConnector from '@material-ui/core/StepConnector';
import createBreakpoints from '@material-ui/core/styles/createBreakpoints';

export const ColorlibConnector = withStyles(theme => ({
  alternativeLabel: {
    top: 45,
    [theme.breakpoints.down('sm')]: {
      top: 30,
    },
  },
  active: {
    '& $line': {
      backgroundColor: '#1473F7',
    },
  },
  completed: {
    '& $line': {
      backgroundColor: '#1473F7',
    },
  },
  line: {
    height: 3,
    border: 0,
    backgroundColor: '#9FB3C8',
    borderRadius: 1,
  },
}))(StepConnector);

export const useStyles = makeStyles(theme => ({
  title: {
    width: 500,
    fontSize: 32,
    fontWeight: 600,
    [theme.breakpoints.down('sm')]: {
      fontSize: 22,
      width: 350,
    },
  },
  subtitleContainer: {
    width: '100%',
    maxWidth: 470,
    marginTop: 13,
  },
  subtitle: {
    fontSize: '16px',
    lineHeight: '26px',
    marginRight: '5px',
  },
  subtitleBold: {
    fontSize: '16px',
    fontWeight: 'bold',
    lineHeight: '26px',
  },
  stepper: {
    width: 735,
    [theme.breakpoints.down('sm')]: {
      marginTop: theme.spacing(0),
      width: '100%',
    },
  },
  card: {
    marginTop: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      marginTop: theme.spacing(3),
    },
    [theme.breakpoints.down('xs')]: {
      marginTop: 0,
    },
  },
  stepperMob: {
    marginTop: theme.spacing(0),
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'center',
    },
  },
  stepLabel: {
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'center',
    },
  },
  giveFeedbackButton: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: theme.spacing(2),
    [theme.breakpoints.down('xs')]: {
      marginTop: 0,
    },
  },
  rounded: {
    borderRadius: 29,
    marginBottom: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      marginBottom: theme.spacing(1),
    },
  },
}));
export const breakpoints = createBreakpoints({});

export const muiTheme = createTheme({
  overrides: {
    MuiStepLabel: {
      label: {
        fontSize: 14,
        fontWeight: 600,
        color: '#9FB3C8',
        '&$active': {
          color: '#9FB3C8',
        },
        '&$completed': {
          fontSize: 14,
          fontWeight: 600,
          color: '#1473F7',
        },
        [breakpoints.down('sm')]: {
          '&$alternativeLabel': {
            fontSize: 10,
            fontWeight: 600,
          },
          '&$active': {
            color: '#9FB3C8',
          },
          '&$completed': {
            color: '#1473F7',
          },
        },
      },
    },
  },
});
